import React, { useEffect, useState } from 'react';
import { DialogControl, FieldControl } from 'spark-core-dx/components';
import { SystemTypes } from 'spark-core-dx/services';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';
import '../../screens/Dashboard.scss';

const IconSelectorDialog = ({ isActive, closeDialog }) => {
  const { selectedTabData, iconSelectData, dashboardLib } = useDashboardDomainContext();
  const [currentIcon, setCurrentIcon] = useState(selectedTabData?.DraftDetails?.Icon || "");

  useEffect(() => {
    setCurrentIcon(selectedTabData?.DraftDetails?.Icon || "");
  }, [selectedTabData?.DraftDetails?.Icon, isActive]);

  return (
    <DialogControl
      className="dashboard-dialog"
      openDialog={isActive}
      title="Edit Dashboard Icon"
      okText="Save"
      onCancel={() => closeDialog()}
      onOk={async () => {
        await dashboardLib.handleDashIconChange(currentIcon);
        closeDialog();
      }}
    >
      <div className="dialog-text">
        <FieldControl
          fieldMetadata={{
            FieldType: SystemTypes.UIFieldType.IconSelect,
            DataJson: iconSelectData,
            DisplayName: "Select an icon",
          }}
          value={currentIcon}
          onChange={setCurrentIcon}
        />
      </div>
    </DialogControl>
  );
};

export default IconSelectorDialog;
